import React, { useState } from 'react';

const STORAGE_KEY = 'analysisTablePalette';
const DEFAULT_COLOR = '#64748b';

const getInitialColor = () => {
    const savedColor = localStorage.getItem(STORAGE_KEY);
    return /^#[0-9a-f]{6}$/i.test(savedColor || '') ? savedColor : DEFAULT_COLOR;
};

const mixColor = (hex, target, targetRatio) => {
    const value = hex.replace('#', '');
    const source = [0, 2, 4].map((offset) => parseInt(value.slice(offset, offset + 2), 16));
    const mixed = source.map((channel, index) => (
        Math.round(channel * (1 - targetRatio) + target[index] * targetRatio)
    ));
    return `rgb(${mixed.join(', ')})`;
};

const createTableColors = (color) => ({
    '--analysis-table-border': mixColor(color, [255, 255, 255], 0.64),
    '--analysis-table-head': mixColor(color, [255, 255, 255], 0.79),
    '--analysis-table-head-text': mixColor(color, [0, 0, 0], 0.42),
    '--analysis-table-row': mixColor(color, [255, 255, 255], 0.98),
    '--analysis-table-alt-row': mixColor(color, [255, 255, 255], 0.92),
    '--analysis-table-hover': mixColor(color, [255, 255, 255], 0.82),
});

const AnalysisTablePalette = ({ children }) => {
    const [selectedColor, setSelectedColor] = useState(getInitialColor);

    const selectColor = (color) => {
        setSelectedColor(color);
        localStorage.setItem(STORAGE_KEY, color);
    };

    return (
        <div className="analysis-table-color-block">
            <div className="analysis-table-palette" role="group" aria-label="Geçmiş maçlar tablosu rengi">
                <span>Tablo rengi</span>
                <input
                    className="analysis-table-color-picker"
                    type="color"
                    value={selectedColor}
                    onChange={(event) => selectColor(event.target.value)}
                    aria-label="Tablo rengini seç"
                    title="RGB renk paletini aç"
                />
                <button
                    type="button"
                    className="analysis-table-color-reset"
                    onClick={() => selectColor(DEFAULT_COLOR)}
                >
                    Sıfırla
                </button>
            </div>
            <div
                className="table-wrapper tt2-table-wrapper analysis-table-colorized"
                style={createTableColors(selectedColor)}
            >
                {children}
            </div>
        </div>
    );
};

export default AnalysisTablePalette;
